export interface Day {
  key: string
  d: number
  m: number
  y: number
  isEnabled: boolean
  isHoliday: boolean
  isSelected: boolean
  isToday: boolean
  isPreSelected: boolean
  showOverlay?: boolean
}

export interface MonthProps {
  ID?: string
  type: CalendarTypes
  month: number
  year: number
  holidayList?: Array<number>
  preSelectedDate?: number
  disableBefore?: number
  disableAfter?: number
  onDateSelected?: (date: Day) => void
  extraData?: boolean
  selectedDate: Date
  onHover?: (day: Day) => void
  hoverFrom: number
  hoverTo: number
  secondSelectedDate?: number
  maxDuration?: number
}

export interface DayProps {
  ID?: string
  day: Day
  firstDate: Date
  onPress: () => void
  onHover?: (day: Day) => void
  hoverFrom: number
  hoverTo: number
}

export interface CalendarViewProps {
  ID?: string
  holidayList?: Array<string>
  preSelectedDate?: Date
  onDateSelected?: (date: Date) => void
  refreshFlag: boolean
  minDate: Date
  maxDate: Date
  type: CalendarTypes
  secondSelectedDate?: Date
  maxDuration?: number
  scrollToCurrentDate?: boolean
}

export enum CalendarTypes {
  SINGLE = 'Single',
  RANGE = 'Range',
  HISTORY = 'History',
  SINGLE_FUTURE = 'SINGLE_FUTURE',
}

export const CalendarTypesOption = {
  SINGLE: CalendarTypes.SINGLE,
  RANGE: CalendarTypes.RANGE,
  HISTORY: CalendarTypes.HISTORY,
  SINGLE_FUTURE: CalendarTypes.SINGLE_FUTURE,
}

export interface CalendarProps {
  ID?: string
  onDateSelected: (firstDate: Date, secondDate?: Date) => void
  holidayList?: Array<string>
  type?: CalendarTypes
  onCancel: () => void
  defaultMinDate?: Date
  defaultMaxDate?: Date
  maxDuration?: number
  scrollToCurrentDate?: boolean
  sendError?: any
}

export interface WeekDayProps {
  ID?: string
  type: CalendarTypes
}

export interface LegendProps {
  ID?: string
  type: CalendarTypes
}

export interface DayProps {
  type: CalendarTypes
  ID?: string
  day: Day
  onPress: () => void
}
